// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2RlVT","file":"styles_file__1s3aU"};